import { toast } from "react-hot-toast";
import { useLocation } from "wouter";
import { database } from "../../database.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useGangContext } from "./useGang.ts";

export function DeleteGangDialog() {
  const { gang } = useGangContext();
  const [_, navigate] = useLocation();

  return (
    <ConfirmDialog
      heading="Delete gang?"
      description={`Are you sure you want to delete ${gang.name}? You cannot undo this.`}
      submitLabel="Delete"
      theme="red"
      onSubmit={() => database.gangs.deleteOne(gang)}
      onSuccess={() => {
        toast("Gang deleted");
        navigate("~/gangs");
      }}
    />
  );
}
